import "../styles/footer.css"
const Footer = function(){
    return (
        <footer>
            <div className="footer-wrapper">
                <p>Made with ❤️ by @monukd01dev</p>
            </div>
        </footer>
    )
};

export default Footer;